// extracted by mini-css-extract-plugin
export default {"input":"NumberSlideInput_input__aTCjM","mark":"NumberSlideInput_mark__O2RY+","value":"NumberSlideInput_value__eQWOQ"};